import { create } from "zustand";

/**
 * Cross-component trigger for the floating Zaviago AI panel in AppRailRight
 * (same pattern as chatPanelStore). Plan 1969 F8: the Zaviago Sheets dashboard
 * "ให้ AI สร้าง" quick start asks the parent to open the AI panel.
 */
interface AiPanelState {
  /** Bumped on each request so the listener effect re-runs every time. */
  nonce: number;
  requestOpen: () => void;
}

export const useAiPanelStore = create<AiPanelState>((set) => ({
  nonce: 0,
  requestOpen: () => set((s) => ({ nonce: s.nonce + 1 })),
}));
